import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductMiniPhoto, { ProductMiniPhotoStyles } from "@store/Widgets/ProductList/ProductMiniPhotoStore";
import React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: ProductDetailsMiniPhotoStyles;
}

type Props = HasProduct & OwnProps;

export interface ProductDetailsMiniPhotoStyles {
    container?: InjectableCss;
    miniPhoto?: ProductMiniPhotoStyles;
}

export const productDetailsMiniPhotoStyles: ProductDetailsMiniPhotoStyles = {
    miniPhoto: {
        wrapper: {
            css: css`
                width: 100%;
                margin: 20px 0 0;
                text-align: center;
            `,
        },
        miniPhotoLink: {
            css: css`
                width: auto;
            `,
        },
    },
};

const ProductDetailsMiniPhoto = ({ extendedStyles, product }: Props) => {
    const [styles] = React.useState(() => mergeToNew(productDetailsMiniPhotoStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.container}>
            <ProductMiniPhoto product={product} extendedStyles={styles.miniPhoto} />
        </StyledWrapper>
    );
};

const storeProductDetailsMiniPhoto: WidgetModule = {
    component: withProduct(ProductDetailsMiniPhoto),
    definition: {
        displayName: "Mini Photo",
        group: "Product Details",
    },
};

export default storeProductDetailsMiniPhoto;
